<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  data(){
    return {
      // modal_component:null,
      // root_validate_errors:[],

    }
  }
}
</script>

<!--<style lang="css">-->
<!--/*// Import Main styles for this application*/-->
<!--/*@import 'assets/css/style.css';*/-->
<!--/*@import 'assets/css/account.css';*/-->
<!--/*@import 'assets/css/page-filme.css';*/-->
<!--/*@import 'fonts';*/-->
<!--</style>-->
